import { clearCache } from "@utils/localCache";
import { PostJsonRequest, PostRequest } from "./http/BaseRequest";
import { allUsersCacheKey } from "@utils/hooks/useCurrentUser";

// export class CreateUserRequest extends PostRequest {
//   constructor(
//     email: string,
//     password: string,
//   ) {
//     clearCache(allUsersCacheKey);
//     super("/admin/user/add", { email, password });
//   }
// }

export class CreateUserRequest extends PostJsonRequest {
  constructor(
    email: string,
    password: string,
    role: string,
  ) {
    clearCache(allUsersCacheKey);
    super("/admin/user/add", { email, password, role });
  }
}